import { ISkill } from '../models'
import { Endpoint, get } from '../util/api'

export type GetSkills = Endpoint<Record<string, never>, { success: true; skills: ISkill[] }>

export const getSkills = () => get<GetSkills>('/skills')
